import { render, staticRenderFns } from "./InfoVenta.vue?vue&type=template&id=305110ab&scoped=true&"
import script from "./InfoVenta.vue?vue&type=script&lang=js&"
export * from "./InfoVenta.vue?vue&type=script&lang=js&"
import style0 from "./InfoVenta.vue?vue&type=style&index=0&id=305110ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305110ab",
  null
  
)

export default component.exports